import React, { Component, useContext, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Button, Grid, Switch, Typography } from '@material-ui/core';
import theme from 'components/theme';

const SwitchItem = (props) => {
  const {
    title = 'No title',
    checked = false,
    onChange = () => console.log('Missing onChange'),
    disabled = false,
    children,
  } = props;

  return (
    <Grid
      container
      item
     
    >
      <Grid item xs={8} alignItems="center" container>
        <Typography>{title}</Typography>
      </Grid>
      <Grid item xs={4} container justifyContent="flex-end" alignItems="center">
        <Switch
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          inputProps={{ 'aria-label': 'controlled' }}
          disabled={disabled}
        />
      </Grid>
      {checked && children}
    </Grid>
  );
};

export default SwitchItem;
